import { createSeatRequestRpc, createSkuRequestRpc, createTrialRequestRpc } from 'growth-monetization-service-types';
import { rpcClient } from '../client';
export const sendRequestTrialNotification = ({
  apiName
}) => rpcClient.call(createTrialRequestRpc, {
  data: {
    apiName
  }
});
export const sendRequestSKUNotification = ({
  apiName
}) => rpcClient.call(createSkuRequestRpc, {
  data: {
    apiName
  }
});
export const sendRequestSeatNotification = ({
  apiName,
  requestReason,
  requestedSeatType
}) => {
  const data = requestedSeatType ? {
    requestedSeatType
  } : {
    apiName
  };
  return rpcClient.call(createSeatRequestRpc, {
    data: Object.assign({}, data, {
      requestReason,
      staged: false
    }),
    queryParameters: {
      sendAdminNotification: true
    }
  });
};